export default {
  Title: 'Profile',

  PersonalInfo: {
    Title: 'Personal Info'
  },
  Addresses: {
    Title      : 'Addresses',
    Default    : 'Default',
    Floor      : 'Floor',
    DoorBell   : 'Door Bell',
    Comment    : 'Instructions',
    UseCustom  : 'Can\'t find your address on the map?',
    NoAddresses: {
      Title   : 'You have not added addresses yet',
      Subtitle: 'Add a new address now'
    },
    Notification: {
      Delete: {
        Title: 'Delete Address?',
        Body : 'Are you sure you want to delete the address?'
      }
    },
    Field: {
      Nickname: {
        Label      : 'Friendly Name',
        Hint       : '',
        Placeholder: 'Friendly Name'
      },

      City: {
        Label      : 'City',
        Hint       : '',
        Placeholder: 'City'
      },

      Postcode: {
        Label      : 'Postcode',
        Hint       : '',
        Placeholder: 'Postcode'
      },

      Street: {
        Label      : 'Street',
        Hint       : '',
        Placeholder: 'Street'
      },

      Number: {
        Label      : 'Number',
        Hint       : '',
        Placeholder: 'Number'
      },

      Floor: {
        Label      : 'Floor',
        Hint       : '',
        Placeholder: 'Floor'
      },

      DoorBell: {
        Label      : 'Door Bell',
        Hint       : '',
        Placeholder: 'Door Bell'
      },

      Comment: {
        Label      : 'Directions',
        Hint       : '',
        Placeholder: 'Directions'
      },

      IsDefault: {
        Label      : 'Default Address',
        Hint       : '',
        Placeholder: 'Default Address'
      }
    },
    Button: {
      Add: {
        Title: 'Add Address',
        Icon : 'mdi-plus'
      },
      Change: {
        Title: 'Change Address',
        Icon : 'mdi-map-marker'
      },
      Select: {
        Title: 'Select Address',
        Icon : 'mdi-map-marker'
      }
    }
  },
  OrderHistory: {
    Title   : 'Order History',
    NoOrders: {
      Title   : 'You haven’t made any orders yet',
      Subtitle: 'You’ll find all the details of your orders here'
    }
  },
  Settings: {
    Title: 'Settings',

    Profile     : 'Profile',
    ChangePass  : 'Change Password',
    Notification: {
      Marketing: 'Marketing Notifications',
      System   : 'System Notifications',
      Delete   : {
        Title     : 'Send PIN',
        Subtitle  : 'Send Confirmation PIN',
        Body      : 'You will receive a PIN in your email to confirm the permanent deletion of your account.',
        ConfirmPin: {
          Title   : 'Enter PIN',
          Subtitle: 'Enter Confirmation PIN',
          Body    : 'The confirmation PIN was sent successfully! Please check your email. <br><br> Enter the PIN you received in your email to confirm the permanent deletion of your account.'
        }
      },
      Export: {
        Title     : 'Send PIN',
        Subtitle  : 'Send Confirmation PIN',
        Body      : 'You will receive a PIN in your email to confirm the export of your account data.',
        ConfirmPin: {
          Title   : 'Enter PIN',
          Subtitle: 'Enter Confirmation PIN',
          Body    : 'The confirmation PIN was sent successfully! Please check your email. <br><br> Enter the PIN you received in your email to confirm the export of your account data.'
        }
      }
    },
    Account      : 'Account',
    DeleteAccount: 'Permanent Account Deletion',
    ExportAccount: 'Export Personal Data',

    Field: {
      Firstname: {
        Label      : 'Firstname',
        Placeholder: 'Firstname',
        Hint       : ''
      },
      Lastname: {
        Label      : 'Lastname',
        Placeholder: 'Lastname',
        Hint       : ''
      },
      Email: {
        Label      : 'Email',
        Placeholder: 'Email',
        Hint       : ''
      },
      Phone: {
        Label       : 'Mobile Phone',
        Placeholder : 'Mobile Phone',
        Hint        : '',
        NotValidated: 'Mobile phone has not been confirmed.'
      },
      Password: {
        Label      : 'Password',
        Placeholder: 'Password',
        Hint       : ''
      },
      NewPass: {
        Label      : 'New Password',
        Placeholder: 'New Password',
        Hint       : ''
      },
      NewPassConfirm: {
        Label      : 'Confirm Password',
        Placeholder: 'Confirm Password',
        Hint       : ''
      },
      Newsletter: {
        Label      : 'Newsletter',
        Placeholder: 'Newsletter',
        Hint       : ''
      },
      Push: {
        Label          : 'Push Notifications',
        Placeholder    : 'Push Notifications',
        PermissionError: 'You must first allow push notifications to browser',
        Hint           : ''
      },
      Sms: {
        Label      : 'SMS',
        Placeholder: 'SMS',
        Hint       : ''
      }
    }
  }
}
